import { FunctionComponent } from "react";
import { StyledSignicat } from "./signicat.styles";
import Button from "./button";
import { useTranslate } from "stores/hooks/translation";
import { faCaretRight } from "./icon-library";

interface SignicatProps {
  onClick: () => Promise<void>;
}

const Signicat: FunctionComponent<SignicatProps> = ({ onClick }) => {
  const translate = useTranslate();
  return (
    <StyledSignicat>
      <Button type="secondary" onClick={onClick} postIcon={faCaretRight}>
        {translate("login_with_ftn")}
      </Button>
    </StyledSignicat>
  );
};

export default Signicat;
